export const authApiHandler = {
  register: {
    register: {
      method: "POST",
      path: () => `auth/register`
    }
  },
  login: {
    login: {
      method: "POST",
      path: () => `auth/login`
    },
    twoFactorAuthentication: {
      method: "POST",
      path: () => `auth/2fa`,
      params: {} as {'token'?: string | number, 'code'?: string | number}
    },
    resendCode: {
      method: "POST",
      path: () => `auth/resend`,
      params: {} as {'token'?: string | number}
    }
  },
  resetPassword: {
    requestResetPassword: {
      method: "POST",
      path: () => `reset-password/request`
    },
    resetPassword: {
      method: "POST",
      path: () => `reset-password/confirm`
    }
  },
  sSO: {
    generateSSOToken: {
      method: "POST",
      path: () => `auth/sso`,
      params: {} as {'courseId'?: string | number, 'portal'?: string | number}
    },
    getTokensUsingSSO: {
      method: "GET",
      path: () => `auth/sso`,
      params: {} as {'token'?: string | number}
    }
  },
  verifyToken: {
    method: "GET",
    path: () => `auth`
  },
  getUserPermissions: {
    method: "GET",
    path: () => `permissions-system`
  },
  logout: {
    method: "POST",
    path: () => `auth/logout`
  },
  refresh: {
    method: "GET",
    path: () => `auth/refresh`,
    params: {} as {'token'?: string | number}
  },
  refresh_New: {
    method: "POST",
    path: () => `auth/refresh`
  },
  deleteAccount: {
    method: "DELETE",
    path: () => `auth/deleteREMOVETHISUPPERCASETEXT`
  },
  masquerade: {
    method: "POST",
    path: () => `auth/masquerade`
  },
  getEmailOrganizations: {
    method: "GET",
    path: () => `auth/organizations`
  },
  getOrganization: {
    method: "GET",
    path: () => `organizations-dashboard`
  },
  validateOrganizationAdminInvitation: {
    method: "GET",
    path: (p: { token: string }) => `auth/organization-admin-invitation/${p.token}`,
  },
  registerOrganizationAdmin: {
    method: "POST",
    path: () => `auth/register-organization-admin`,
  },
};